export class GetCompanyStatus {
    constructor(companyRepository) {
      this.companyRepository = companyRepository;
    }
  
    async execute(CompanyId) {
      console.log('I am in GetCompanyStatus usecase');
      return await this.companyRepository.getCompanyStatus(CompanyId);
    }
  }